import {
    ODataHeader,
    ODataString
} from "pbas-vue-components";
import { translate2 } from '../trans2'

const EmployerContactsHeaders = [
    // new ODataHeader({
    //   type: new ODataString("Employer/Name"),
    //   sortable: true,
    //   visible: false,
    //   searchable: true,
    //   version: 2,
    //   allowVisibilityChange: false,
    // }),
    // new ODataHeader({
    //   title: "globals.employer",
    //   type: new ODataString("Employer/Translations[]/Name", {
    //     getString: (item) => translate2(item.Employer, "Name"),
    //   }),
    //   sortable: true,
    //   visible: true,
    //   searchable: true,
    //   version: 1,
    //   orderByKey: "Name",
    // }),
    // new ODataHeader({
    //   type: new ODataString("Employer/Translations[]/LanguageCode"),
    //   sortable: false,
    //   visible: false,
    //   allowVisibilityChange: false,
    //   searchable: false,
    // }),
    // new ODataHeader({
    //   type: new ODataString("Employer/Translations[]/Id"),
    //   sortable: false,
    //   visible: false,
    //   allowVisibilityChange: false,
    //   searchable: false,
    // }),
    // new ODataHeader({
    //   type: new ODataString("Employer/Translations[]/RefId"),
    //   sortable: false,
    //   visible: false,
    //   allowVisibilityChange: false,
    //   searchable: false,
    // }),
    // new ODataHeader({
    //   title: "Employer Id",
    //   type: new ODataString("Employer/Id"),
    //   visible: false,
    //   allowVisibilityChange: false,
    //   searchable: false,
    // }),
    new ODataHeader({
      title: "EmployerId",
      type: new ODataString("EmployerId"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
  ];
export default EmployerContactsHeaders;